import { WidgetLazyLoader } from 'components/common/WidgetLazyLoader';
import { configuration } from 'config/constants';
import React, { FC } from 'react';

declare global {
    namespace React {
        namespace JSX {
            interface IntrinsicElements {
                'sgwt-splash-screen': { application: string };
            }
        }
    }
}

export const SplashScreen: FC = () => {
    return (
        <WidgetLazyLoader script={`${configuration.widgetCdnBaseUrl}/widgets/sgwt-splash-screen/v4/sgwt-splash-screen.js`}>
            <sgwt-splash-screen
                application="subscription"
            />
        </WidgetLazyLoader>
    );
};
